import { HVIcon, HVTooltip } from "@repo/HVComponents";
import { ICON } from "src/constants/icons";
import { useLang } from "@hooks/useLang";
import * as S from "./OrderItem.styled";

interface OrderItemProps {
  title: string;
  icon: React.ReactNode | null;
  disabled?: boolean;
}
export const OrderItem = (props: OrderItemProps) => {
  const { translate } = useLang();

  return (
    <S.Container disabled={props.disabled}>
      <S.Content className="drag-handle">
        <S.Info>
          <HVIcon name="drag" svgProps={{ ...ICON.SIZE_20 }} />
          {props.icon}
          <span>{props.title}</span>
        </S.Info>
        {!!props.disabled && (
          <S.Help>
            <HVTooltip
              variant="Information"
              label=""
              tooltipProps={{
                label: translate("not_supported_in_single_location"),
                children: null,
                zIndex: 1000,
                position: "bottom"
              }}
            />
          </S.Help>
        )}
      </S.Content>
    </S.Container>
  );
};
